import React from "react";
import ConfirmationModal from "../../../common/components/ConfirmationModal";
import ApiClient from "../../../common/API";
import { useQueryClient } from "react-query";
import { toast } from 'react-toastify';
import DeleteIcon from '@mui/icons-material/Delete';
import handleError from "../ErrorHandling"

export default function DeleteGroup({ group, isOpen, setsetIsOpen }) {
    const queryClient = useQueryClient();

    const closeModal = () => {
        setsetIsOpen(false);
    };

    const handleDelete = () => {
        ApiClient().delete(`group/${group.id}/`)
            .then(() => {
                queryClient.invalidateQueries(['group'])
                queryClient.invalidateQueries(['user'])
                closeModal();
                return toast.success('Group deleted!');
            })
            .catch(error => {
                console.error(error);
                const errorMessage = handleError(error, "Group", "delete");
                return toast.error(errorMessage);
            });
    };

    return (
        <>
            {isOpen && (
                <ConfirmationModal
                    isOpen={isOpen}
                    onClose={closeModal}
                    onConfirm={handleDelete}
                    icon={<DeleteIcon sx={{ fontSize: '60px' }} color="error" />}
                    title="Delete Group"
                    message={`Are you sure you want to delete the group "${group.name}"? ${group.is_public ? 'This is a public group visible to all users.' : `This will remove ${group.users?.length || 0} member${group.users?.length !== 1 ? 's' : ''} from the group.`} This action cannot be undone.`}
                />
            )}
        </>
    )
}